import { VSlideYTransition } from 'vuetify/lib/components/transitions';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-control-messages",class:{ 'show-as-error': !_vm.isFocussed && _vm.isTouched && _vm.hasAtLeastOneMessage }},[_c(VSlideYTransition,[(_vm.hasAtLeastOneMessage && _vm.areMessagesShown)?_c('div',{staticClass:"message"},[_vm._v(" "+_vm._s(_vm.firstMessage)+" ")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }